module.exports = __webpack_public_path__ + "img/check-off.6f23bb4a.svg";